// extracted by mini-css-extract-plugin
module.exports = {"textarea":"_inputtextarea_textarea__2V6Y2","inputLabel":"_inputtextarea_inputLabel__3aZSH"};